export default () => useRuntimeConfig().public.version.toUpperCase().split('-')[0];
